// 验证用户有没有权限访问接口
import router from '@/router'
import {
  getToken
} from '@/utils/auth'

/**
 * 判断用户是否有权限访问api接口
 * @param funcname {String} 接口方法名称，用于判断该方法是否需要登录状态（必须）
 * @param callback {Promise}axios请求方法
 * @param roles {Array} 权限要求的角色，如果不存在则无权限要求（可选）
 */
export function apiPermission (funcname, roles, callback) {
  // 白名单，不要求用户登录
  const whiteList = ['login', 'studyGetVideoList']
  // let userType
  // 获取token，判断有没有登录
  if (getToken()) {
    // 已经登录的用户，如果接口有角色限制，需要验证
    callback()
  } else {
    // 未登录的用户，在白名单的接口，不需要登录要求
    if (whiteList.indexOf(funcname) !== -1) {
      // 不要求登录
      callback()
    } else {
      // 没有登录的用户，无权限访问不在白名单内的接口，跳转到登录界面，让用户登录
      router.replace({
        path: '/login',
        query: {
          from: router.currentRoute.path
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/permission.js